export enum V3DashboardCardVariants {
    primary = "primary",
    secondary = "secondary"
}